import { useCookies } from 'react-cookie'
import { IUniversalCart } from '../types'
import { RawCookieName } from '../constants'

const mkpCartCountCookieName = RawCookieName.CART_COUNT

export function useUniversalHeaderCart(): IUniversalCart {
  const [cookies] = useCookies([mkpCartCountCookieName])
  const mkpCartCount = cookies[mkpCartCountCookieName] ?? 0

  return {
    url: `/shop/cart`,
    count: mkpCartCount,
  }
}
